var map = {
	"./cardBg-l.png": "./src/assets/industryChainNew/cardBg-l.png",
	"./cardBg.png": "./src/assets/industryChainNew/cardBg.png",
	"./company1.png": "./src/assets/industryChainNew/company1.png",
	"./mode1.png": "./src/assets/industryChainNew/mode1.png",
	"./mode2.png": "./src/assets/industryChainNew/mode2.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/industryChainNew sync recursive ^\\.\\/.*\\.png$";